import React from "react";
import PropTypes from "prop-types";
import bagIcon from "BSM/assets/StoreIconWhite.png";
import styles from "./StatsTotalCard.module.css";

export function StatsTotalCard({ total, title, sixWeekAvg }) {
  return (
    <div className={styles.card}>
      <div className={styles.iconWrapper}>
        <img src={bagIcon} alt="bagIcon" />
      </div>

      <div className={styles.details}>
        {title && <p className={styles.title}>{title}</p>}
        {total && <p className={styles.total}>{total}</p>}
        {sixWeekAvg && (
          <p className={styles.sixWeekAvg}>6 Week Average: {sixWeekAvg}</p>
        )}
      </div>
    </div>
  );
}

StatsTotalCard.propTypes = {
  total: PropTypes.string,
  title: PropTypes.string,
  sixWeekAvg: PropTypes.string,
};
